// API Configuration
export const API_CONFIG = {
  BASE_URL: 'https://seemanchaldecor.in/api',
  ENDPOINTS: {
    // Authentication
    LOGIN: '/auth/login',
    CREATE_ADMIN: '/auth/create-admin',
    
    // Dashboard
    DASHBOARD_COUNTS: '/dashboard/counts',
    
    // Projects
    PROJECTS_ONGOING_LIST: '/projects/ongoing/list',
    PROJECTS_ONGOING: '/projects/ongoing',
    PROJECTS_COMPLETED: '/projects/completed',
    PROJECTS_ALL: '/projects/all',
    PROJECTS_CREATE: '/projects/',
    PROJECTS_BY_ID: (id) => `/projects/${id}`,
    PROJECTS_LINK_CLIENT: (id) => `/projects/${id}/link-client`,
    PROJECTS_UPDATES: (id) => `/projects/${id}/updates/`,
    PROJECTS_UPDATE_BY_ID: (projectId, updateId) => `/projects/${projectId}/updates/${updateId}`,
    PROJECTS_ROOMS: (id) => `/projects/${id}/rooms/`,
    PROJECTS_ROOM_BY_ID: (projectId, roomId) => `/projects/${projectId}/rooms/${roomId}`,
    PROJECTS_ROOM_TIMELINE: (projectId, roomId) => `/projects/${projectId}/rooms/${roomId}/timeline`,
    PROJECTS_ROOM_TIMELINE_IMAGES: (projectId, roomId) => `/projects/${projectId}/rooms/${roomId}/timeline/images`,
    PROJECTS_ROOM_UPDATES: (projectId, roomId) => `/projects/${projectId}/rooms/${roomId}/updates`,
    
    // Inquiries (Contacts)
    INQUIRIES_CREATE: '/inquiries/contact',
    INQUIRIES_RECENT: '/inquiries/recent',
    INQUIRIES_ALL: '/inquiries/',
    INQUIRIES_BY_ID: (id) => `/inquiries/${id}`,
    
    // Employees (Admin)
    EMPLOYEES_ALL: '/employees/',
    EMPLOYEES_CREATE: '/employees/',
    EMPLOYEES_FREE: '/employees/free',
    EMPLOYEES_BY_ID: (id) => `/employees/${id}/`,
    EMPLOYEES_ASSIGN: (employeeId, projectId) => `/employees/${employeeId}/assign/${projectId}`,
    EMPLOYEES_UNASSIGN: (employeeId, projectId) => `/employees/${employeeId}/unassign/${projectId}`,
    
    // Employee Portal
    EMPLOYEE_LOGIN: '/employee/auth/login',
    EMPLOYEE_PROFILE: '/employee/profile',
    
    // Clients
    CLIENTS_ALL: '/clients/',
    CLIENT_SIGNUP: '/client/auth/signup',
    CLIENT_LOGIN: '/client/auth/login',
    CLIENT_PROJECTS: '/client/projects',
    CLIENT_PROJECT_BY_ID: (id) => `/client/projects/${id}`,
    
    // System
    ROOT: '/',
    HEALTH: '/health'
  },
  TIMEOUT: 10000, // 10 seconds
  RETRY_ATTEMPTS: 3,
  RETRY_DELAY: 1000 // 1 second base delay for exponential backoff
};

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
};

export const TOKEN_STORAGE_KEY = 'seemanchal_admin_token';
export const USER_STORAGE_KEY = 'seemanchal_admin_user';